import {
	type GetOrdersPartnerNamesFetchResponse,
	getOrdersPartnerNames,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const ORDER_PARTNER_NAMES_KEY = "ORDER_PARTNER_NAMES";

export function useOrderPartnerNames(orderIds: string[]) {
	const uniqueOrderIds = [...new Set(orderIds.map(Number))].sort(
		(left, right) => left - right,
	);

	return useQuery({
		queryKey: [ORDER_PARTNER_NAMES_KEY, uniqueOrderIds],
		queryFn: processResponse<unknown, GetOrdersPartnerNamesFetchResponse>(
			() => getOrdersPartnerNames(uniqueOrderIds),
			{ skipToastFor: true },
		),
		select: (records) =>
			new Map(
				records.map((record) => [
					String(record.orderId),
					record.partnerName ?? null,
				]),
			),
		enabled: uniqueOrderIds.length > 0,
		refetchInterval: 30_000,
		retry: false,
	});
}
